import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import IslandModal from 'shared/components/modals/IslandModal'
import Flex from 'shared/ui/Flex'

const Description = styled.span`
  color: ${({ theme }) => theme.color.base.c6};
`

const LoadingContainer = styled.div`
  margin-top: 46px;
`

const LoadingBar = styled.div<{ percent: number }>`
  margin-top: 10px;
  width: 100%;
  height: 8px;
  background: ${({ theme }) => theme.color.base.c2};
  border-radius: 10px;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    width: ${({ percent }) => percent}%;
    height: 100%;
    border-radius: 10px;
    background-color: ${({ theme }) => theme.color.brand_02};
    transition: width 0.2s;
  }
`

const LoadingLabel = styled.span`
  color: ${({ theme }) => theme.color.base.c9};
  font-weight: 600;
`

type PageMigrationModalProps = {
  isOpen: boolean
  loadingPercent: number
}

const PageMigrationModal: React.FC<PageMigrationModalProps> = ({
  isOpen,
  loadingPercent
}) => {
  const { formatMessage } = useIntl()

  const [_isOpen, _setIsOpen] = useState(isOpen)

  useEffect(() => {
    _setIsOpen(isOpen)
  }, [isOpen])

  const title = formatMessage({
    id: 'Editor.modals.automation.title'
  })
  const description = formatMessage({
    id: 'Editor.modals.automation.description'
  })
  const loadingLabel = formatMessage({
    id: 'Editor.modals.automation.loadingBar.label'
  })

  return (
    <IslandModal
      isOpen={_isOpen}
      closeModal={() => _setIsOpen(false)}
      title={title}
      titleMargin={8}
      titleAlign="left"
      width={344}
    >
      <Flex direction="column" justifyContent="space-between">
        <Description>{description}</Description>

        <LoadingContainer>
          <LoadingLabel>{loadingLabel}</LoadingLabel>
          <LoadingBar percent={loadingPercent} />
        </LoadingContainer>
      </Flex>
    </IslandModal>
  )
}

export default PageMigrationModal
